import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { map } from "lodash";
import { mergeCss } from "mrb/common/utils";
import { MrbButton } from "mrb/components/button";

const FeaturedSectionPageToolbarTemplate = observer(function FeaturedSectionPageToolbarTemplate({ store, t }) {
    const {
        pages,
        pageCount,
        currentPageIndex,
        canAddPage,
        canDeletePage,
        addPage,
        deletePage,
        goToPreviousPage,
        goToNextPage,
    } = store;

    const current = Math.max(currentPageIndex + 1, 1);
    const total = Math.max(pageCount, 1);

    return (
        <div className="c-featured-pages__toolbar">
            {/* Page navigation (arrows + counter + dots) is one self-contained, centered unit,
                laid out independently of the actions column so neither ever shifts the other. */}
            <div className="c-featured-pages__toolbar__center">
                <div className="c-featured-pages__toolbar__pager">
                    <MrbButton
                        t={t}
                        aria-label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.PREVIOUS_PAGE")}
                        onlyIcon
                        icon="u-icon u-icon--med u-icon--arrow-left"
                        onClick={goToPreviousPage}
                        disabled={pageCount <= 1}
                        classNameOverride="c-btn c-featured-pages__toolbar__pager__arrow c-featured-pages__toolbar__pager__arrow--prev"
                    />

                    <span className="c-featured-pages__toolbar__pager__counter">
                        <span className="c-featured-pages__toolbar__pager__counter__current">{current}</span>
                        <span className="c-featured-pages__toolbar__pager__counter__sep">/</span>
                        <span className="c-featured-pages__toolbar__pager__counter__total">{total}</span>
                    </span>

                    <MrbButton
                        t={t}
                        aria-label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.NEXT_PAGE")}
                        onlyIcon
                        icon="u-icon u-icon--med u-icon--arrow-right"
                        onClick={goToNextPage}
                        disabled={pageCount <= 1}
                        classNameOverride="c-btn c-featured-pages__toolbar__pager__arrow c-featured-pages__toolbar__pager__arrow--next"
                    />
                </div>

                <div className="c-featured-pages__dots">
                    {map(pages, (page, index) => (
                        <span
                            key={page.id}
                            className={mergeCss(
                                "c-featured-pages__dots__dot",
                                index === currentPageIndex && "c-featured-pages__dots__dot--active"
                            )}
                        />
                    ))}
                </div>
            </div>

            <div className="c-featured-pages__toolbar__actions">
                <MrbButton
                    t={t}
                    label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.ADD_PAGE")}
                    aria-label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.ADD_PAGE")}
                    icon="u-icon u-icon--base u-icon--plus u-mar--right--tny"
                    onClick={addPage}
                    disabled={!canAddPage}
                    classNameOverride="c-btn c-btn--base c-btn--primary"
                />

                <MrbButton
                    t={t}
                    label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.DELETE_PAGE")}
                    aria-label={t("ADMINISTRATION.NAKI_MOBILE.FEATURED_SECTION.PAGES.DELETE_PAGE")}
                    icon="u-icon u-icon--base u-icon--trash u-mar--right--tny"
                    onClick={deletePage}
                    disabled={!canDeletePage}
                    classNameOverride="c-btn c-btn--base c-btn--ghost"
                />
            </div>
        </div>
    );
});

FeaturedSectionPageToolbarTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default FeaturedSectionPageToolbarTemplate;
